export default {
  data: () => ({
    search: null
  }),
  watch: {
    $query () {
      this.search = null
    }
  },
  computed: {
    query () {
      return this.search !== null ? this.search : (this.$route.params.query || '')
    },

    $query () {
      return this.$route.params.query
    }
  },
  methods: {
    onInput (e) {
      this.search = e.target.value
    },
    doSearch () {
      if (this.search.trim().length < 1) {
        return
      }

      this.$router.push({name: 'Search', params: {query: this.search.trim()}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js